import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy } from '@ngneat/until-destroy';
import { finalize, Observable } from 'rxjs';

import { CreateOrUpdateLicencePackageDto } from '../dtos/CreateLicencePackageDto.interface';
import { LicenceDataDto } from '../dtos/getPackageDto.type';
import { LicenceStatusDto } from '../dtos/licenceStatusDto';
import { RoutesUtil } from '../util/RoutesUtil';

@UntilDestroy()
@Injectable()
export class LicenceService {
    /**
     *
     * @param http the http client instance
     * @param config the configurations for the library
     */
    constructor(private http: HttpClient, private coreProvider: AumicoCoreProvider, private routesUtil: RoutesUtil) {}

    createPackage(organizationId: string, dto: CreateOrUpdateLicencePackageDto): Observable<LicenceDataDto> {
        const url = this.routesUtil.createLicencePackageUrl(organizationId);
        return this.http.post<LicenceDataDto>(url, dto);
    }

    updatePackage$(dto: CreateOrUpdateLicencePackageDto): Observable<LicenceDataDto> {
        this.coreProvider.dispatchBlockingRequest('UsersFe_updatePackage');

        const url = this.routesUtil.updateLicencePackageUrl(dto.organizationId, dto.packageId);
        return this.http
            .put<LicenceDataDto>(url, dto)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_updatePackage')));
    }

    getLicenceStatus$(organizationId: string): Observable<LicenceStatusDto> {
        //It's a non-blocking request, so we don't need to dispatch a blocking request
        const url = this.routesUtil.getLicenceStatusUrl(organizationId);
        return this.http.get<LicenceStatusDto>(url).pipe();
    }

    requestLicenceUpgrade$(organizationId: string): Observable<void> {
        this.coreProvider.dispatchBlockingRequest('UsersFe_requestLicenceUpgrade');
        const url = this.routesUtil.requestLicenceUpgradeUrl(organizationId);
        return this.http
            .post<void>(url, null)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_requestLicenceUpgrade')));
    }

    deletePackage$(packageId: string, organizationId: string): Observable<void> {
        this.coreProvider.dispatchBlockingRequest('UsersFe_deletePackage$');
        const url = this.routesUtil.deleteLicencePackageUrl(packageId, organizationId);
        return this.http
            .delete<void>(url)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('UsersFe_deletePackage$')));
    }
}
